export default {
  AWS: {
    REGION: "us-west-2",
    API: `https://45itrwynkg.execute-api.us-west-2.amazonaws.com/staging`,
    S3: "portalcondominio-data"
  }
};



// WEBPACK FOOTER //
// ./src/config.js